import DailyStatsList from './DailyStatsList'

export default { list: DailyStatsList }
